import {RouteProps} from 'config/navigation';

import Notifications from './notifications';
import CreateNotification from './create-notification';
import EditNotification from './edit-notification';
import {FaBell} from 'react-icons/fa';

const notificationsPages: RouteProps = {
  name: 'Notificações',
  path: 'notifications',
  permission: 'notifications.findAll',
  icon: <FaBell />,
  subRoutes: [
    {
      path: '',
      element: <Notifications />,
      permissions: ['notifications.findAll'],
    },
    {
      path: 'create',
      element: <CreateNotification />,
      permissions: ['notifications.findOne'],
    },
    {
      path: ':id',
      element: <EditNotification />,
      permissions: ['notifications.findOne'],
    },
  ],
};

export default notificationsPages;
